<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
          title="核酸检测"
          left-arrow
          left-text="返回"
          @click-left="onClickLeft"
        />
      <div class="top"></div>
    </div>
  <div>
        <div class="test_title" >
      <div class="title_info">
        <div class="title_name">姓名：{{name}}</div>
        <div class="title_cardno">卡号：{{medCardNo}}</div>
      </div>
      <div class="title_icon" @click.stop="show=true">
        <van-icon name="exchange" size="7vw" color="#5B8DF6" />
        <div>切换</div>
      </div>
    </div>
    <van-popup v-model="show" round  position="top" :style="{ height: '30%' }" >
        <div class="pop_cell"  v-for="(item,index) in cardList" :key="index" @click="changeinfo(item)">
            <div class="pop_name">{{item.clientName}}</div>
            <div class="pop_card">{{item.medCardNo}}</div>
        </div>
    </van-popup>
    <div class="Tips">
      <p>
        <div>温馨提示：</div>
        <div v-for="(item,index) in tips" :key="index">{{item.value}}</div>
        
      </p>
    </div>
   
  </div>
    <div class="foot">
        <div class="a_btn">
            <van-button type="info" block @click="godetail()">确认检测</van-button>
        </div>
        <div class="b_btn">
            <van-button plain type="info" block @click="onClickLeft">取消</van-button>
        </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import { Dialog } from "vant";
import setOptions from "@/mixins/setOption";
export default {
   mixins: [setOptions],
  components: {
    Nav,
  },
  data() {
    return {
      show: false,
      showName: "",
      fee: "",
      reportAddress: "",
      feeType: "",
      medCardNo: "",
      name: "",
      cardList: [],
      tips: [],
      path: "",
      wxid:""
    };
  },
  methods: {
    showDialog() {
      Dialog.alert({
        title: "清廉承诺",
        messageAlign:"left",
        message:
          "为规范医疗秩序，严厉整治打击医疗乱象，我们承诺：\n一、不收红包。\n二、不收受礼品。\n三、不进行术中加价。\n四、不指定院外购药。\n五、不骗取医疗保障基金。\n六、不接受病人及亲属吃请。\n七、不进行过度检查、过度诊疗。\n八、不违规超量、超限制开具药品或耗材。\n九、不重复收费、捆绑收费、串换收费、超量收费。\n十、不参与供应商的推销活动和虚假医疗广告宣传。我们真诚接受广大人民群众和社会各界的监督。\n弥勒市卫生健康局监督举报电话：\n<span style='color:red'>0873—6122360，08733029379</span>\n弥勒市纪委市监委监督举报方式：\n电话举报：<span style='color:red'>0873—6122585</span>\n来信举报：弥勒市纪委市监委信访室  邮编：652399\n来访举报：弥勒市行政中心1—18室"
      }).then(() => {
        // on close
      });
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    changeinfo(item) {
      this.medCardNo = item.medCardNo;
      this.name = item.clientName;
      this.show = false;
    },
    godetail() {
      this.$router.push({
        path: "/acidtest_detail",
        query: {
          clientId: this.medCardNo,
        },
      });
    },
    async getinfo() {
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
      try {
        this.$showLoad();
        let url = "/register/getAcidSeeting";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          null,
          (data) => {
            console.log(data.data);
            this.reportAddress = data.data.reportAddress;
            this.tips = data.data.tips;
            this.feeType = data.data.feeType;
            this.showName = data.data.showName;
            this.fee = data.data.fee;
            this.wxid=data.data.wx_pub_id;
            if(this.wxid=="1012"){
              this.showDialog()
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
    async getmedicalcard() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/medicalcard/getclientcardlist";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            console.log(data);
            this.cardList = [...data.data];
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  mounted() {
    //
    if (
      this.path == "/patient_card_confUser_C" ||
      this.path == "/patient_card_selectuser"
    ) {
      if (!this.$route.query.clientId) {
        this.$router.push("/index");
        return;
      }
    }
    if (this.$route.query) {
      this.medCardNo = this.$route.query.clientId;
      this.name = this.$route.query.name;
      // console.log(this.medCardNo)
    }
    if (!this.medCardNo || this.medCardNo == "") {
      // console.log(this.medCardNo);
      this.$router.push("/patient_card_confUser_C");
      return
      // this.Dialog();
    }
    this.getinfo();
    this.getmedicalcard();
  },
};
</script>

<style  lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: #f7f7f7;
  .pop_cell {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 6vh;
    width: 95%;
    margin: 0px auto;
  }
  .nav {
    height: 6vh;
    width: 100%;
    .top {
      height: 12vh;
      width: 100%;
      background-color: #5b8df6;
    }
  }
  .test_title {
    display: flex;
    flex-direction: row;
    height: 15vh;
    width: 93%;
    margin: 0px auto;
    font-size: 16px;
    margin-top: 3vh;
    border: 1px solid white;
    background-color: white;
    border-radius: 6px;
    .title_info {
      width: 60vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .title_icon {
      width: 40vw;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
  .Tips {
    width: 93%;
    margin: 0px auto;
    height: 60vh;
    font-size: 16px;
    margin-top: 2vh;
    margin-bottom: 4vh;
    background-color: white;
    border: 1px solid white;
    padding: 5px;
    line-height: 4vh;
    border-radius: 6px;
    .red {
      color: #c44569;
    }
  }

  .foot {
    width: 90%;
    margin: 0px auto;
    height: 7vh;
    display: flex;
    flex-direction: row;
    .a_btn {
      width: 50%;
      margin-right: 8vw;
    }
    .b_btn {
      width: 50%;
    }
  }
}
</style>